import React from 'react';
import { withTranslate } from 'react-redux-multilingual';
import { useNavigate, Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import ParametersTableHeader from '../../Blocks/ParametersTableHeader';
import ParametersTypeValue from '../../Blocks/ParametersTypeValue';
import ReturnTypeValue from '../../Blocks/ReturnTypeValue';

function Vi(props) {
    const { translate } = props;
    return (
        <Box>
            <Typography variant="h5" gutterBottom id="listfiles">
                1.&nbsp;<span className="material-symbols-outlined">snippet_folder</span>&nbsp;{translate('listfiles')}
            </Typography>
            <p><strong>{translate('listfiles')}</strong> là một hành động truy xuất danh sách các tệp trong một thư mục.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$listFiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn thư mục. Nhập <strong>/tmp</strong> để chỉ định thư mục gốc.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('fullpath')}<span>*</span></td>
                                <td>
                                    <div className='type-value'>
                                        <span className="material-symbols-outlined">rule</span>
                                        <span>{translate('datatype__any')}</span>
                                    </div>
                                </td>
                                <td>Là tuỳ chọn truy xuất đường dẩn tuyệt đối của tệp, nếu công tắc <strong>{translate('fullpath')}</strong> được bật (true) thì kết quả sẽ là danh sách đường dẩn tuyệt đối dưới dạng mảng.</td>
                                <td>false</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Lấy danh sách các tệp nằm bên trong thư mục <strong>/tmp/download</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$listFiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('directory')}</span>
                            <div>/tmp/download</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "file_1.xlsx"
                                            ,"file_2.pdf"
                                            ,"file_3.png"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="renamefile">
                2.&nbsp;<span className="material-symbols-outlined">edit_document</span>&nbsp;{translate('renamefile')}
            </Typography>
            <p><strong>{translate('renamefile')}</strong> là một hành động đổi tên một tệp. Xin lưu ý rằng phần mở rộng sẽ không được thay đổi.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$renamefile_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tệp muốn đổi tên.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên mới của tệp.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Thay đổi tên tệp <strong>file_1.xlsx</strong> thành <strong>report.xlsx</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$renamefile_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_1.xlsx</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>report</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/download/report.xlsx</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="movefiles">
                3.&nbsp;<span className="material-symbols-outlined">drive_file_move</span>&nbsp;{translate('movefiles')}
            </Typography>
            <p><strong>{translate('movefiles')}</strong> là một hành động thay đổi thư mục lưu trữ của một hoặc nhiều tệp.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$moveFiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của một hoặc nhiều tệp muốn di chuyển. Trường hợp nhiều tệp thì đường dẩn của các tệp phải được ngăn cách bằng dấu phẩy.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn thư mục đích đến. Nhập <strong>/tmp</strong> để chỉ định thư mục gốc.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Thay đổi thư mục lưu trữ tệp <strong>file_2.pdf</strong> từ <strong>/tmp/download</strong> thành <strong>/tmp/document</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$moveFiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_2.pdf</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>/tmp/document</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/document/file_2.pdf"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="deletefiles">
                4.&nbsp;<span className="material-symbols-outlined">folder_delete</span>&nbsp;{translate('deletefiles')}
            </Typography>
            <p><strong>{translate('deletefiles')}</strong> là hành động xóa một hoặc nhiều tệp.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của một hoặc nhiều tệp muốn xoá. Trường hợp nhiều tệp thì đường dẩn của các tệp phải được ngăn cách bằng dấu phẩy.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Xoá tệp <strong>file_2.pdf</strong> trong thư mục <strong>/tmp/document</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/document/file_2.pdf</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="copyfiles">
                5.&nbsp;<span className="material-symbols-outlined">file_copy</span>&nbsp;{translate('copyfiles')}
            </Typography>
            <p><strong>{translate('copyfiles')}</strong> là một hành động sao chép một hoặc nhiều tệp.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$copyfiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của một hoặc nhiều tệp muốn sao chép. Trường hợp nhiều tệp thì đường dẩn của các tệp phải được ngăn cách bằng dấu phẩy.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('directory')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn thư mục đích. Nhập <strong>/tmp</strong> để chỉ định thư mục gốc.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Sao chép tệp <strong>file_3.png</strong> từ <strong>/tmp/download</strong> sang <strong>/tmp/document</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$moveFiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_3.png</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>/tmp/document</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/document/file_3.png"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="compressfiles">
                6.&nbsp;<span className="material-symbols-outlined">folder_zip</span>&nbsp;{translate('compressfiles')}
            </Typography>
            <p><strong>{translate('compressfiles')}</strong> là một hành động để nén một hoặc nhiều tệp thành tập tin ZIP.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$compressfiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của một hoặc nhiều tệp muốn nén. Trường hợp nhiều tệp thì đường dẩn của các tệp phải được ngăn cách bằng dấu phẩy.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('filename')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là tên tập tin sau khi nén.</td>
                                <td></td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="text" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Nén <strong>file_1.xlsx,file_2.pdf,file_3.png</strong> trong <strong>/tmp/download</strong> thành <strong>all_files.zip</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$compressfiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/file_1.xlsx,/tmp/download/file_2.pdf,/tmp/download/file_3.png</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filename')}</span>
                            <div>all_files</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>/tmp/download/all_files.zip</div>
                        </div>
                    </div>
                </li>
            </ul>
            <Typography variant="h5" gutterBottom id="decompressfiles">
                7.&nbsp;<span className="material-symbols-outlined">folder_zip</span>&nbsp;{translate('decompressfiles')}
            </Typography>
            <p><strong>{translate('decompressfiles')}</strong> là một hành động để giải nén một tập tin ZIP.</p>
            <ul style={{ listStyle: "none" }}>
                <p>
                    <strong>a.&nbsp;{translate('parameters__title')}</strong>
                </p>
                <li>
                    <table className='parameters'>
                        <ParametersTableHeader />
                        <tbody>
                            <tr>
                                <td>{translate('outputkey')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là nơi lưu trữ kết quả đầu ra của hành động này.</td>
                                <td>$decompressfiles_1</td>
                            </tr>
                            <tr>
                                <td>{translate('filepath')}<span>*</span></td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Là đường dẫn của tập tin ZIP.</td>
                                <td></td>
                            </tr>
                            <tr>
                                <td>{translate('encoding')}</td>
                                <td>
                                    <ParametersTypeValue type="text" />
                                </td>
                                <td>Chỉ định mã hóa ký tự của tệp nén. Nếu tên tệp sau khi mở rộng chứa các ký tự tiếng Nhật, các ký tự có thể bị cắt xén. Bạn có thể ngăn các ký tự bị cắt xén bằng cách chỉ định mã ký tự.</td>
                                <td>UTF-8</td>
                            </tr>
                        </tbody>
                    </table>
                </li>
                <p>
                    <strong>b.&nbsp;{translate('returndatatype__title')}</strong>
                </p>
                <li>
                    <ReturnTypeValue type="array" />
                </li>
                <p>
                    <strong>c.&nbsp;{translate('example__title')}</strong>
                </p>
                <li>
                    <p>Giả nén tập tin <strong>all_files.zip</strong> trong thư mục <strong>/tmp/download</strong>.</p>
                    <div className='results'>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('outputkey')}</span>
                            <div>$decompressfiles_1</div>
                        </div>
                        <div className='parameter'>
                            <span className='parameter-name'>{translate('filepath')}</span>
                            <div>/tmp/download/all_files.zip</div>
                        </div>
                        <div className='output'>
                            <span className='output-symbol'>&#61;&gt;&nbsp;</span>
                            <div>      
                                <pre>
                                    {JSON.stringify(
                                        [
                                            "/tmp/download/file_1.xlsx"
                                            ,"/tmp/download/file_2.pdf"
                                            ,"/tmp/download/file_3.png"
                                        ], null, 2)}
                                </pre>
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </Box>
    );
}
export default withTranslate(Vi);